import { calcPostage } from '../api/modules/orders'
import { isSuccessStatus } from '../utils/http'

const minQty = 1
const maxQty = 99

export default {
  namespaced: true,
  state: {
    // カート
    cart: [],
    packings: [],
  },
  getters: {
    cart: state => state.cart,
    packings: state => state.packings,
    // 商品数量計
    totalQty(state) {
      let count = 0
      state.cart.forEach(item => {
        count += item.qty
      })
      return count
    },
    // 商品金額計
    merchandiseSubTotal(state) {
      let amount = 0
      state.cart.forEach(item => {
        amount += item.amount
      })
      return amount
    },
    // 商品送料計
    postageSubTotal(state) {
      let amount = 0
      state.packings.forEach(item => {
        amount += item.amount
      })
      return amount
    },
    // 商品サイズ別集計
    totalBySize(state) {
      return state.cart.reduce((result, current) => {
        const element = result.find((p) => p.size === current.size)
        if (element) {
          element.qty += current.qty // sum
        } else {
          result.push({
            size: current.size,
            qty: current.qty
          })
        }
        return result
      }, [])
    },
    // 特別価格商品チェック
    existSpPrice: state => state.cart.some(item => item.priceTypeId != 0)
  },
  mutations: {
    // 商品追加
    addItem(state, item) {

      const index = state.cart.findIndex(itm =>
        (itm.merchandiseId == item.merchandiseId) &&
        (itm.priceTypeId == item.priceTypeId) &&
        (itm.size == item.size)
      )
      const isExist = index != -1

      if (isExist) {
        // 既に存在する商品は商品数量追加
        const target = state.cart[index]
        target.qty += item.qty
        if (target.qty < minQty) target.qty = minQty
        if (maxQty < target.qty) target.qty = maxQty
        target.amount = target.price * target.qty
      }
      else {
        // 追加
        state.cart.push(item)
      }
    },
    addQty(state, { item, qty }) {
      const index = state.cart.findIndex(itm =>
        (itm.merchandiseId == item.merchandiseId) &&
        (itm.priceTypeId == item.priceTypeId) &&
        (itm.size == item.size)
      )
      const isExist = index != -1

      if (isExist) {
        const target = state.cart[index]
        target.qty += qty
        if (target.qty < minQty) target.qty = minQty
        if (maxQty < target.qty) target.qty = maxQty
        target.amount = target.price * target.qty
      }
    },
    // 商品削除
    removeItem(state, item) {
      const index = state.cart.findIndex(itm =>
        (itm.merchandiseId == item.merchandiseId) &&
        (itm.priceTypeId == item.priceTypeId) &&
        (itm.size == item.size)
      )
      const isExist = index != -1

      if (isExist) {
        state.cart.splice(index, 1)
      }
    },
    // 全削除
    removeAll(state) {
      state.cart = []
    },
    updatePackings(state, packings) {
      state.packings = packings
    }
  },
  actions: {
    // 商品をカートに追加
    addItem({ commit }, item) {
      commit('addItem', item)
    },
    // 数量＋１
    incrementQty({ commit }, item) {
      commit('addQty', {
        item,
        qty: 1
      })
    },
    // 数量−１
    decrementQty({ commit }, item) {
      commit('addQty', {
        item,
        qty: -1
      })
    },
    // 商品をカートから削除
    removeItem({ commit }, item) {
      commit('removeItem', item)
    },
    // カートを空にする
    clearCart({ commit }) {
      commit('removeAll')
    },
    async calcPostage({ commit, dispatch, getters }, area_id) {

      const result = await calcPostage({ areaId: area_id, lists: getters.totalBySize })

      if (isSuccessStatus(result.statusCode)) {
        const data = result.response
        const packings = []
        data.forEach(element => {
          packings.push({
            merchandiseId: 0,
            priceTypeId: 0,
            size: 0,
            packingId: element.packing_id,
            price: Number(element.price),
            qty: Number(element.qty),
            amount: Number(element.price) * Number(element.qty),
            packing_name: element.packing_name,
            youpack_size: element.youpack_size,
            overweight: Boolean(element.overweight),
          })
        })
        commit('updatePackings', packings)
      }
      else {
        dispatch('error/setError', { code: result.statusCode, id: result.requestId, message: result.response }, { root: true })
      }
    },
    clearPackings({ commit }) {
      commit('updatePackings', [])
    },
  },
}
